import react, { useCallback, useState } from 'react';
import { GoCheck } from 'react-icons/go';
import { GiSquare } from 'react-icons/gi';
import { IoClose } from 'react-icons/io5';
import { HiMinusCircle } from 'react-icons/hi';
import { IPayItemInPaystatement } from 'types/salary';

interface IProps {
  sectionType: '지급' | '공제';
  ToggleSectionPopup: (type?: '지급' | '공제') => void;
  toggleSectionItem: (data: any, item: any) => void;
  data: IPayItemInPaystatement[];
  AddSection: (text: string) => void;
  DeleteSection: (name: string) => void;
}

const SectionPopup = ({
  sectionType,
  ToggleSectionPopup,
  toggleSectionItem,
  data,
  AddSection,
  DeleteSection,
}: IProps) => {
  const [AddSectionInput, setAddSectionInput] = useState<string>('');

  const SectionList = useCallback(
    ({ index, item }: { index: number; item: IPayItemInPaystatement }) => {
      return (
        <div className="SectionItem">
          <div className="SectionListCheckBox">
            <input
              type="checkbox"
              id={`item${item.ITEM_INDEX}`}
              checked={item.USE_YN == 'Y' ? true : false}
              onChange={() => {
                toggleSectionItem(data, item);
              }}
            />
            <label htmlFor={`item${item.ITEM_INDEX}`}>
              <div className="SectionListCheckBoxIcon">
                {item.USE_YN == 'Y' ? <GoCheck size={22} color="#000" /> : <GiSquare size={20} color="#aaa" />}
              </div>
              <div className="SectionListName">
                <span>
                  {item.ITEM == '식대' || item.ITEM == '자가운전보조금' || item.ITEM == '육아수당'
                    ? `${item.ITEM}(비과세)`
                    : item.ITEM.replace('_D', '')}
                </span>
              </div>
            </label>
            {item.type == '1' && (
              <button
                onClick={() => {
                  DeleteSection(item.ITEM);
                }}>
                <HiMinusCircle size={26} color="#E71F2D" />
              </button>
            )}
          </div>
        </div>
      );
    },
    [data],
  );

  return (
    <div className="SectionPopup">
      <div className="SectionPopupInner">
        <div style={{ marginTop: 20 }}>
          <strong style={{ color: '#777' }}>입력중인 급여가 있다면 공제계산 또는 저장 후, 항목을 설정해 주세요</strong>
        </div>
        <div>
          <strong style={{ color: '#777' }}>항목 선택 시 저장되지 않은 현재 작성중인 입력값이 모두 없어집니다.</strong>
        </div>
        <div className="SectionList">
          {data.map((i: IPayItemInPaystatement, index) => {
            if (i.USE_YN !== 'D' && ((sectionType === '지급' && index > 1) || (sectionType === '공제' && index > 5))) {
              return <SectionList key={`sectionItem_${sectionType}_${i.ITEM_INDEX}`} index={index} item={i} />;
            }
          })}
        </div>
        <div className="SectionAdd">
          <input
            type="text"
            name="AddSectionInput"
            placeholder="기타 항목 입력"
            value={AddSectionInput}
            onChange={(e) => {
              setAddSectionInput(e.target.value);
            }}
            maxLength={10}
          />
          <button
            onClick={() => {
              AddSection(AddSectionInput);
              setAddSectionInput('');
            }}>
            항목추가
          </button>
        </div>
      </div>
    </div>
  );
};

export default SectionPopup;
